const translation = {
    title: 'Bienvenido a Laboria',
    language: 'Idioma',
    nav: {
        home: 'Inicio',
        aboutUs: 'Nosotros',
        services: 'Servicios',
        h2aVisa: 'Visa H2-A',
        h2bVisa: 'Visa H2-B',
        ourServices: 'Nuestros Servicios',
        contact: 'Contacto',
        contactUs: 'Contactanos',
        openings: 'Vacantes',
        steps: 'Pasos'
    },
    landing: {
        applyNow: 'Aplica ahora',
        contactUs: 'Contactanos',
        showMore: 'Contactanos',
        clientTalentTitle: '¿Estás buscando talento de primer nivel para tu trabajo estacional?',
        clientTalentDescription: 'Encuentra el personal calificado que necesitas',
        legallyUs: `¿No sabes como trabajar legalmente en ESTADOS UNIDOS?`,
        helpYou: '¡Nosotros te ayudamos!',
        applicantTitle: '¿Te gustaría postularte para una oportunidad de trabajo?',
        applicantDescription: 'Te ayudaremos durante el proceso',
        clientTitle: '¿Estas buscando recursos de primer nivel para tus vacantes temporales? ',
        clientDescription: 'Adquiere nuestros servicios.',
        process: {
            identify: 'Identificamos tus habilidades',
            find: 'Buscamos el mejor trabajo para ti',
            handle: 'Nos encargamos del proceso'
        }
    },
    openings: {
        title: 'Vacantes disponibles',
        details: {
            description: "Descripción",
            location: "Ubicación",
            salary: "Salario",
            apply: "Aplicar"
        },
        list: {
            position: 'Posición',
            field: 'Campo',
            description: 'Descripción',
            location: 'Ubicación',
            options: 'Opciones'
        }
    },
    steps: {
        personalInfo: 'Información personal',
        dsForm: 'DS-160'
    },
    forms: {
        yes: 'Si',
        no: 'No',
        personalInfo: {
            idIsNotValid: 'Ya existe una aplicación con este número de identificación',
            howManyKidsRequired: 'Este campo es requerido cuando tiene hijos',
            howManyKidsMin: 'Debe ser al menos 1',
            howManyKidsPattern: 'Debe ser un número válido',
            id: 'Identificación',
            name: 'Nombre',
            middleName: 'Segundo nombre',
            lastName: 'Apellidos',
            gender: 'Género',
            maritalStatus: 'Estado civil',
            partnerName: 'Nombre del cónyuge',
            haveKids: '¿Tiene hijos?',
            howManyKids: '¿Cuántos hijos tiene?',
            educationLevel: 'Nivel educativo',
            profession: 'Profesión u ocupación',
            speaksEnglish: '¿Habla inglés?',
            englishLevel: 'Nivel de inglés',
            workExperience: 'Experiencia laboral',
            workExperienceMaxLength: 'La experiencia laboral debe tener 200 caracteres o menos',
            workExperienceTooltip: 'Agregue la información más relevante de experiencia laboral',
            havePassport: '¿Tiene pasaporte?',
            passportExpiration: 'Fecha de expiración del pasaporte',
            passportExpirationRequired: 'La fecha de expiración del pasaporte es requerida',
            visa: '¿Ha recibido algún tipo de visa de los Estados Unidos?',
            country: 'País',
            state: 'Departamento',
            city: 'Ciudad',
            address: 'Dirección',
            phone: 'Número de teléfono',
            birthDate: 'Fecha de nacimiento',
            haveEmail: '¿Tiene correo electrónico?',
            email: 'Correo electrónico',
            emailRequired: 'El correo electrónico es requerido',
            emailPattern: 'Por favor ingrese un correo electrónico válido',
            next: 'Siguiente'
        },
        genderOptions: {
            male: 'Masculino',
            female: 'Femenino',
            other: 'Prefiero no decirlo'
        },
        maritalStatusOptions: {
            single: 'Soltero/a',
            married: 'Casado/a',
            divorced: 'Divorciado/a',
            widowed: 'Viudo/a',
            separated: 'Separado/a'
        },
        educationalLevels: {
            noFormalEducation: 'Sin educación formal',
            primaryEducation: 'Educación primaria',
            secondaryEducation: 'Educación secundaria',
            vocationalQualification: 'Cualificación vocacional',
            bachelorDegree: 'Grado de licenciatura',
            masterDegree: 'Grado de maestría',
            doctorate: 'Doctorado o superior'
        },
        englishLevels: {
            basic: "Básico",
            intermediate: "Intermedio",
            advanced: "Avanzado",
            fluent: "Fluido"
        },
        visaTypes: {
            No: "No",
            B2: "Visa de visitante (B-2)",
            B1: "Visa de negocios (B-1)",
            H1B: "Visa de trabajo temporal (H-1B)",
            F1: "Visa de estudiante (F-1)",
            J1: "Visa de visitante de intercambio (J-1)",
            K1: "Visa de prometido/a (K-1)",
            CR1: "Visa de cónyuge (CR-1/IR-1)",
            E2: "Visa de inversionista (E-2)",
            O1: "Visa de artista/académico (O-1)",
            R1: "Visa de trabajador religioso (R-1)"
        },
        professions: {
            agriculture: "Agricultura/Ganadería",
            construction: "Trabajador de Construcción",
            hospitality: "Hospitalidad/Turismo",
            manufacturing: "Manufactura",
            landscaping: "Jardinería/Paisajismo",
            housekeeping: "Limpieza/Mantenimiento",
            cooking: "Cocinero/Chef",
            mechanic: "Mecánico",
            electrician: "Electricista",
            plumber: "Plomero",
            painter: "Pintor",
            driver: "Conductor",
            security: "Guardia de Seguridad",
            cleaner: "Limpiador",
            waiter: "Mesero/Mesera",
            cashier: "Cajero",
            sales: "Representante de Ventas",
            fishing: "Pesca",
            textile: "Trabajador Textil",
            teacher: "Maestro",
            nurse: "Enfermero",
            engineer: "Ingeniero",
            softwareEngineer: "Ingeniero de Software",
            other: "Otro"
        },
        dsForm: {
            haveDirectRelativeInUS: "¿Tiene algún familiar directo en Estados Unidos, sin incluir a sus padres?",
            relatives: "¿Cuál es su relación con ellos?",
            relativesRequired: "Por favor seleccione una relación",
            cousin: "Primo/Prima",
            brotherOrSister: "Hermano o Hermana",
            brotherInLaw: "Cuñado/Cuñada",
            husbandOrWife: "Esposo o Esposa",
            uncles: "Tío o Tía",
            deniedVisa: "¿Le han negado la visa alguna vez?",
            howLongWasVisaDenied: "¿Hace cuánto tiempo le negaron la visa?",
            howLongWasVisaDeniedRequired: "Este campo es requerido cuando la visa fue negada",
            lessThanOneYear: "Menos de un año",
            oneToFiveYears: "Entre 1 y 5 años",
            moreThanFiveYears: "Más de 5 años",
            canceledVisa: "¿Le han cancelado la visa alguna vez?",
            whenWasVisaCanceled: "¿Cuándo le cancelaron la visa?",
            whenWasVisaCanceledRequired: "La fecha es requerida cuando la visa fue cancelada",
            citizenRequest: "¿Ha solicitado la ciudadanía en los Estados Unidos alguna vez?",
            currentlyWithVisaProcess: "¿Está actualmente en un proceso de visa?",
            whatKindOfVisaIsProcessing: "¿Qué tipo de visa está siendo procesada?",
            whatKindOfVisaIsProcessingRequired: "El tipo de visa es requerido cuando está en proceso",
            outOfCountryLastFiveYears: "¿Ha salido del país en los últimos 5 años?",
            visitedCountries: "¿Qué países ha visitado?",
            haveBeenOut: "¿Ha residido en otro país por más de 6 meses después de haber cumplido 16 años?",
            triedEnterIllegallyToUs: "¿Ha intentado ingresar a los Estados Unidos de manera ilegal alguna vez?"
        },
        contact: {
            companyName: "Nombre de la empresa",
            companyDescription: "Descripción de la empresa",
            contactName: "Nombre de contacto",
            phoneNumber: "Número telefonico",
            country: "País",
            state: "Estado/Departamento",
            city: "Ciudad",
            address: "Dirección",
            email: "Correo",
            message: "Mensaje",
            send: "Envíar"
        }
    },
    auth: {
        signUp: {
            email_label: 'Tu correo electrónico',
            password_label: 'Crea tu contraseña',
            email_input_placeholder: 'Tu correo electrónico',
            password_input_placeholder: 'Tu contraseña',
            button_label: 'Registrarse',
            loading_button_label: 'Registrando ...',
            link_text: "¿No tienes una cuenta? Inicia sesión",
            confirmation_text: "Revisa tu correo para confirmar tu cuenta"
        },
        signIn: {
            email_label: "Correo electrónico",
            password_label: "Tu contraseña",
            email_input_placeholder: "Tu correo electrónico",
            password_input_placeholder: "Tu contraseña",
            button_label: "Inicia sesión",
            loading_button_label: "Iniciando sesión ...",
            social_provider_text: "Sign in with {{provider}}",
            link_text: "¿Ya tienes una cuenta? Inicia sesión"
        },
        forgottenPassword: {
            email_label: "Dirección de correo electrónico",
            password_label: "Tu contraseña",
            email_input_placeholder: "Tu dirección de correo electrónico",
            button_label: "Enviar instrucciones para restablecer la contraseña",
            loading_button_label: "Enviando instrucciones de restablecimiento ...",
            link_text: "¿Olvidaste tu contraseña?",
            confirmation_text: "Revisa tu correo electrónico para obtener el enlace de restablecimiento de contraseña"
        }
    },
    client: {
        setUpTitle: 'Antes de comenzar, solo necesitamos completar algunos datos.',
        email: 'Correo electrónico',
        organizationName: 'Nombre de organización',
        phoneNumber: 'Número de teléfono'
    },
    whatWeDo: {
        findPeople: 'Encontramos personas que ayudarán a que tu negocio sea un éxito.',
        ethicalRecruitment: 'Te aseguramos un proceso de reclutamiento',
        process: 'ético',
        deliverTalent: 'Entregamos el mejor talento de América Latina'
    },
    confirmation: {
        thankYou: '¡Gracias por tu interés!',
        emailSent: 'Te hemos enviado un correo de confirmación',
        instructions: 'Por favor revisa tu bandeja de entrada y sigue las instrucciones del correo. Nos pondremos en contacto contigo pronto.',
        backHome: 'Volver al Inicio'
    },
    aboutUs: {
        whatWeDo: '¿Qué hacemos?',
        description: `En LABORIA, somos especialistas en reclutamiento internacional, conectando talento calificado de Latinoamérica con empresas en los Estados Unidos que necesitan cubrir posiciones temporales en sectores como hospitalidad, construcción, jardinería y más. Nos destacamos por ofrecer un servicio integral que incluye reclutamiento, selección y trámites migratorios, asegurando cumplimiento normativo en cada etapa del proceso.
Nuestro compromiso es proporcionar soluciones laborales confiables y efectivas, optimizando la fuerza laboral de nuestros clientes mientras transformamos las oportunidades de vida de nuestros colaboradores. Con un enfoque en excelencia, integridad y transparencia, LABORIA no solo facilita procesos legales, sino que construye puentes entre oportunidades y desarrollo personal, impulsando el éxito de todos los involucrados.`,
        howWeDoIt: '¿Cómo lo hacemos?',
        howWeDoItDescription: 'En LABORIA, trabajamos bajo un enfoque integral y profesional que asegura resultados efectivos:',
        howWeDoitList: {
            step1: `Búsqueda y selección: Identificamos y evaluamos a los candidatos que cumplen con los requisitos específicos de nuestros clientes, garantizando talento confiable y calificado.`,
            step2: 'Gestión migratoria: Nos encargamos de todos los trámites necesarios, incluyendo visas H2A y H2B, asegurando cumplimiento legal en cada etapa.',
            step3: 'Soporte continuo: Mantenemos una comunicación constante con los empleadores y trabajadores, resolviendo dudas y ofreciendo acompañamiento durante todo el proceso.',
            step4: 'Transparencia y confiabilidad: Informamos claramente los pasos del proceso, brindando confianza a todos los involucrados.',
        },
        ourMision: 'Nuestra misión',
        mision: 'Conectamos a empresas en los Estados Unidos con talento calificado de Latinoamérica, ofreciendo soluciones laborales integrales en sectores como hospitalidad, construcción, jardinería y más. Transformamos vidas a través de oportunidades laborales temporales seguras y éticas, asegurando cumplimiento normativo y excelencia en el servicio. Somos el puente de confianza entre empresas y colaboradores, promoviendo el crecimiento económico y profesional de ambos.',
        ourVision: 'Nuestra visión',
        vision: 'Convertirnos en el líder en reclutamiento internacional en Honduras, reconocido por nuestra excelencia, innovación y compromiso con procesos legales y éticos. A mediano plazo, expandir nuestras operaciones a otros países de Latinoamérica, posicionándonos como la primera opción para empresas en los Estados Unidos que buscan talento calificado y para trabajadores que desean construir un futuro mejor a través de oportunidades laborales seguras. Aspiramos a transformar el mercado laboral internacional, promoviendo igualdad de oportunidades y fortaleciendo comunidades a ambos lados de la frontera.'
    },
    footer: {
        companyDescription: 'Conectando talento con oportunidades',
        businessHours: 'Horario de atención: Lunes a viernes de 8:00 AM a 5:00 PM (Hora de Honduras, Centroamérica)',
        quickLinks: 'Enlaces Rápidos',
        followUs: 'Síguenos',
        allRightsReserved: 'Todos los derechos reservados.'
    },
    common: {
        back: 'Volver'
    },
    h2aVisa: {
        title: 'Visa H2-A',
        subtitle: 'Programa de Trabajadores Agrícolas Temporales - Conectando trabajadores agrícolas calificados con granjas estadounidenses',
        whatIsTitle: '¿Qué es la Visa H2-A?',
        whatIsDescription1: 'La visa H2-A es una visa de no inmigrante que permite a los empleadores estadounidenses traer extranjeros a los Estados Unidos para llenar trabajos agrícolas temporales.',
        whatIsDescription2: 'Este programa está específicamente diseñado para abordar la escasez de mano de obra estacional en el sector agrícola, asegurando que las granjas estadounidenses puedan mantener su productividad durante las temporadas pico de cosecha.',
        whatIsDescription3: 'La visa H2-A es renovable y permite a los trabajadores permanecer en los EE.UU. hasta por un año, con la posibilidad de extensiones hasta por tres años.',
        whoIsForTitle: '¿Para quién es esta Visa?',
        employersTitle: 'Para Empleadores Estadounidenses:',
        employersDescription: 'Negocios agrícolas, granjas y ranchos que necesitan trabajadores temporales para trabajos agrícolas estacionales.',
        workersTitle: 'Para Trabajadores Extranjeros:',
        workersDescription: 'Trabajadores agrícolas calificados de países elegibles que buscan oportunidades de empleo temporal en los Estados Unidos.',
        requirementsTitle: 'Requisitos Básicos:',
        requirementsDescription: 'Debe tener al menos 18 años, tener experiencia agrícola y ser de un país que tenga un tratado con los EE.UU. para este tipo de visa.',
        benefitsTitle: 'Beneficios Clave del Programa de Visa H2-A',
        benefit1: 'Trabajo Legal',
        benefit1Desc: 'Trabajar legalmente en los EE.UU. con documentación apropiada',
        benefit2: 'Salarios Justos',
        benefit2Desc: 'Salarios justos y condiciones de trabajo garantizadas',
        benefit3: 'Vivienda',
        benefit3Desc: 'Vivienda proporcionada por el empleador o subsidio de vivienda',
        benefit4: 'Transporte',
        benefit4Desc: 'Transporte hacia y desde los EE.UU. incluido',
        howWeHelpTitle: 'Cómo Laboria Ayuda con el Procesamiento de Visa H2-A',
        howWeHelpSubtitle: 'Manejamos todo el proceso de principio a fin',
        step1: '1. Aplicación',
        step1Desc: 'Completar aplicación de visa y documentación',
        step2: '2. Procesamiento',
        step2Desc: 'Manejar todo el procesamiento gubernamental y aprobaciones',
        step3: '3. Apoyo',
        step3Desc: 'Apoyo continuo durante todo el proceso',
        step4: '4. Éxito',
        step4Desc: 'Asegurar aprobación exitosa de visa y llegada',
        clientSectionTitle: 'Para Empleadores Estadounidenses y Negocios Agrícolas',
        clientBenefitsTitle: '¿Por qué Elegir Trabajadores H2-A?',
        clientBenefit1: 'Fuerza laboral estacional confiable durante los tiempos pico de cosecha',
        clientBenefit2: 'Trabajadores calificados con experiencia agrícola',
        clientBenefit3: 'Cumplimiento con las leyes laborales y regulaciones estadounidenses',
        clientBenefit4: 'Períodos de empleo flexibles (hasta 3 años)',
        clientRequirementsTitle: 'Requisitos del Empleador',
        clientRequirement1: 'Demostrar necesidad temporal o estacional de trabajadores',
        clientRequirement2: 'Pagar salarios prevalecientes y proporcionar vivienda',
        clientRequirement3: 'Cubrir costos de transporte hacia y desde los EE.UU.',
        clientRequirement4: 'Asegurar cobertura de compensación laboral',
        clientCtaButton: 'Contratar Trabajadores H2-A',
        applicantSectionTitle: 'Para Trabajadores Agrícolas que Buscan Empleo en EE.UU.',
        applicantBenefitsTitle: 'Beneficios para los Trabajadores',
        applicantBenefit1: 'Autorización de trabajo legal en los Estados Unidos',
        applicantBenefit2: 'Salarios competitivos con condiciones laborales justas',
        applicantBenefit3: 'Vivienda proporcionada por el empleador o subsidio de vivienda',
        applicantBenefit4: 'Transporte de ida y vuelta incluido',
        applicantRequirementsTitle: 'Requisitos del Trabajador',
        applicantRequirement1: 'Mínimo 18 años de edad',
        applicantRequirement2: 'Experiencia comprobada en trabajo agrícola',
        applicantRequirement3: 'Ciudadano de país elegible con tratado',
        applicantRequirement4: 'Disposición para trabajar en trabajos agrícolas estacionales',
        applicantCtaButton: 'Aplicar para Trabajos H2-A',
        applicantCtaSubtext: 'Explora posiciones agrícolas disponibles y comienza tu aplicación',
        ctaTitle: '¿Listo para Comenzar tu Proceso de Visa H2-A?',
        ctaDescription: 'Contacta a nuestro equipo hoy para aprender más sobre cómo podemos ayudarte con tu aplicación de visa H2-A. Estamos aquí para guiarte a través de cada paso del proceso.',
        ctaButton: 'Contáctanos Hoy'
    },
    h2bVisa: {
        title: 'Visa H2-B',
        subtitle: 'Programa de Trabajadores No Agrícolas Temporales - Conectando trabajadores calificados con empresas estadounidenses',
        whatIsTitle: '¿Qué es la Visa H2-B?',
        whatIsDescription1: 'La visa H2-B es una visa de no inmigrante que permite a los empleadores estadounidenses traer extranjeros a los Estados Unidos para llenar trabajos no agrícolas temporales.',
        whatIsDescription2: 'Este programa aborda la escasez de mano de obra en varios sectores incluyendo hospitalidad, construcción, jardinería, servicio de alimentos y otras industrias estacionales o de carga máxima.',
        whatIsDescription3: 'La visa H2-B permite a los trabajadores permanecer en los EE.UU. hasta por un año, con la posibilidad de extensiones hasta por tres años en total.',
        whoIsForTitle: '¿Para quién es esta Visa?',
        employersTitle: 'Para Empleadores Estadounidenses:',
        employersDescription: 'Negocios en hospitalidad, construcción, jardinería, servicio de alimentos y otras industrias que necesitan trabajadores temporales para trabajo estacional o de carga máxima.',
        workersTitle: 'Para Trabajadores Extranjeros:',
        workersDescription: 'Trabajadores calificados de países elegibles que buscan oportunidades de empleo temporal en sectores no agrícolas en los Estados Unidos.',
        requirementsTitle: 'Requisitos Básicos:',
        requirementsDescription: 'Debe tener al menos 18 años, tener experiencia laboral relevante y ser de un país que tenga un tratado con los EE.UU. para este tipo de visa.',
        benefitsTitle: 'Beneficios Clave del Programa de Visa H2-B',
        benefit1: 'Trabajo Legal',
        benefit1Desc: 'Trabajar legalmente en los EE.UU. con documentación apropiada',
        benefit2: 'Salarios Justos',
        benefit2Desc: 'Salarios justos y condiciones de trabajo garantizadas',
        benefit3: 'Vivienda',
        benefit3Desc: 'Vivienda proporcionada por el empleador o subsidio de vivienda',
        benefit4: 'Transporte',
        benefit4Desc: 'Transporte hacia y desde los EE.UU. incluido',
        howWeHelpTitle: 'Cómo Laboria Ayuda con el Procesamiento de Visa H2-B',
        howWeHelpSubtitle: 'Manejamos todo el proceso de principio a fin',
        step1: '1. Aplicación',
        step1Desc: 'Completar aplicación de visa y documentación',
        step2: '2. Procesamiento',
        step2Desc: 'Manejar todo el procesamiento gubernamental y aprobaciones',
        step3: '3. Apoyo',
        step3Desc: 'Apoyo continuo durante todo el proceso',
        step4: '4. Éxito',
        step4Desc: 'Asegurar aprobación exitosa de visa y llegada',
        clientSectionTitle: 'Para Empresas y Empleadores Estadounidenses',
        clientBenefitsTitle: '¿Por qué Elegir Trabajadores H2-B?',
        clientBenefit1: 'Fuerza laboral estacional confiable durante períodos pico de negocio',
        clientBenefit2: 'Trabajadores calificados con experiencia en la industria relevante',
        clientBenefit3: 'Cumplimiento con las leyes laborales y regulaciones estadounidenses',
        clientBenefit4: 'Períodos de empleo flexibles (hasta 3 años)',
        clientRequirementsTitle: 'Requisitos del Empleador',
        clientRequirement1: 'Demostrar necesidad temporal o estacional de trabajadores',
        clientRequirement2: 'Pagar salarios prevalecientes y proporcionar vivienda',
        clientRequirement3: 'Cubrir costos de transporte hacia y desde los EE.UU.',
        clientRequirement4: 'Asegurar cobertura de compensación laboral',
        clientCtaButton: 'Contratar Trabajadores H2-B',
        applicantSectionTitle: 'Para Trabajadores que Buscan Empleo en EE.UU.',
        applicantBenefitsTitle: 'Beneficios para los Trabajadores',
        applicantBenefit1: 'Autorización de trabajo legal en los Estados Unidos',
        applicantBenefit2: 'Salarios competitivos con condiciones laborales justas',
        applicantBenefit3: 'Vivienda proporcionada por el empleador o subsidio de vivienda',
        applicantBenefit4: 'Transporte de ida y vuelta incluido',
        applicantRequirementsTitle: 'Requisitos del Trabajador',
        applicantRequirement1: 'Mínimo 18 años de edad',
        applicantRequirement2: 'Experiencia comprobada en la industria relevante',
        applicantRequirement3: 'Ciudadano de país elegible con tratado',
        applicantRequirement4: 'Disposición para trabajar en posiciones temporales',
        applicantCtaButton: 'Aplicar para Trabajos H2-B',
        applicantCtaSubtext: 'Explora posiciones disponibles y comienza tu aplicación',
        ctaTitle: '¿Listo para Comenzar tu Proceso de Visa H2-B?',
        ctaDescription: 'Contacta a nuestro equipo hoy para aprender más sobre cómo podemos ayudarte con tu aplicación de visa H2-B. Estamos aquí para guiarte a través de cada paso del proceso.',
        ctaButton: 'Contáctanos Hoy'
    }
};


export default {
    translation
}